/**
 * The routes that render the Radar app surface and therefore keep a
 * light/dark choice (dark-first). Every other route is light only.
 *
 * One list for the three places that apply the rule: the root layout's
 * first-paint THEME_BOOTSTRAP and server-side theme, and ThemeProvider on
 * client-side navigation. The owner pilot routes joined the dashboard on
 * 2026-11-05 (PIX-207), when they moved into the Radar app shell.
 */
export const RADAR_THEMED_PREFIXES = [
  '/platform/app',
  '/admin/monitoring',
  '/admin/improvements',
] as const

export function isRadarThemedPath(pathname: string | null | undefined) {
  if (!pathname) return false
  return RADAR_THEMED_PREFIXES.some(
    prefix => pathname === prefix || pathname.startsWith(`${prefix}/`)
  )
}
